import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../../../modules/auth';
import _ from 'lodash';

const filterObject = {
  blcCd: 'AUTH',
  mlcCd: 'USR',
  useYn: 'Y',
};

const UserRoleMultiCheckbox = ({
  name,
  label,
  variant,
  margin,
  size,
  required,
  checkedList,
  onChangeChecked,
}) => {
  const [checkList, setCheckList] = React.useState([]);

  const dispatch = useDispatch();
  const { baseCodes, error, loading } = useSelector(({ auth, loading }) => ({
    baseCodes: auth.baseCodes,
    error: auth.baseCodesError,
    loading: loading['auth/GET_BASECODES'],
  }));

  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    } else {
      const filteredList = _.filter(baseCodes, filterObject);
      const orderedList = _.orderBy(filteredList, 'step');
      setCheckList(orderedList);
    }
  }, [baseCodes]);

  return (
    <Box>
      <Typography variant="subtitle2" component="div">
        {label}
      </Typography>
      <Box>
        {checkList &&
          checkList.map((item, index) => {
            const findIndex = _.findIndex(
              checkedList,
              (checked) =>
                checked?.authYn === 'Y' && checked.authTyp === item.revVal2,
            );
            const checked = findIndex !== -1 ? true : false;
            return (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={checked}
                    name={item.revVal2}
                    onChange={(e) => onChangeChecked(item, e.target.checked)}
                  />
                }
                label={item.revVal1}
              />
            );
          })}
      </Box>
    </Box>
  );
};

export default UserRoleMultiCheckbox;
